import { T as DT } from '../../designTokens';

// SEVERITY_ORDER, SECTION_META and the status→label map used to be declared
// here a second time, diverging from designTokens.ts (#990) — FixList,
// ReportHero and IssueCard now import those directly from designTokens.ts.
// Font stacks come straight from designTokens.ts (T.font*, #1979); rgba()
// literal unification is tracked separately (#1980).

// Report-local aliases over the design tokens (designTokens.ts stays the
// single source of the underlying values).
export const T = {
  // typography
  display: DT.fontDisplay,

  // document header palette (light, #1937)
  bg: DT.gray50,
  surface: DT.white,
  surfaceAlt: DT.gray50,
  border: DT.gray200,
  borderStrong: DT.gray300,
  text: DT.gray900,
  textMuted: DT.gray600,
  textFaint: DT.gray500,
  accent: DT.cobalt600,

  // light body palette
  lightBg: DT.gray50,
  lightSurface: DT.white,
  lightBorder: DT.gray200,
  lightText: DT.gray700,
  lightMuted: DT.gray500,
};
